import { RootState } from "@/app/stores"
import { getPartnerDiscounts, IListPartnerDiscounts } from "@/shared/api/partners"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchPartnerDiscounts = createAsyncThunk<
    IListPartnerDiscounts,
    void,
    { state: RootState }
>('partnerDiscounts/fetchPartnerDiscounts', async (_, thunkAPI) => {
    try {
        const { selectedPartner, page, limit } = thunkAPI.getState().partnerDiscounts
        const data = await getPartnerDiscounts(page, limit, selectedPartner ? [selectedPartner] : null)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})